<template>
	<div id="divLogoLine">
		<div id="longLogos">
			<a v-for="(logo, key) in logos" :key="key" :href="logo.href">
				<img
					v-bind:src="imgToStaticPath(logo.src)"
					v-bind:alt="createAlt(logo)"
				/>
			</a>
		</div>
		<div id="smallLogo">
			<a :href="small_logo.href">
				<img
					v-bind:src="imgToStaticPath(small_logo.src)"
					v-bind:alt="createAlt(small_logo)"
				/>
			</a>
		</div>
		<h1 class="application_title">ApplyMaine</h1>
	</div>
</template>

<script>
export default {
	name: "LogoLine",
	data: function() {
		return {
			logos: [
				{
					alt: "University of Maine",
					href: "http://umaine.edu",
					src: "logoUM.png"
				},
				{
					alt: "University of Maine Augusta",
					href: "http://uma.edu",
					src: "logoUMA.png"
				},
				{
					alt: "University of Maine Farmington",
					href: "http://umf.maine.edu",
					src: "logoUMF.png"
				},
				{
					alt: "University of Maine Fort Kent",
					href: "http://umfk.edu",
					src: "logoUMFK.jpg"
				},
				{
					alt: "University of Maine at Machias",
					href: "https://machias.edu",
					src: "logoUMM.png"
				},
				{
					alt: "University of Southern Maine",
					href: "https://usm.maine.edu",
					src: "logoUSM.jpg"
				},
				{
					alt: "University of Maine Presque Isle",
					href: "http://umpi.edu",
					src: "logoUMPI.png"
				}
			],
			small_logo: {
				alt: "University of Maine System",
				href: "http://www.maine.edu",
				src: "ums-logo.png"
			}
		};
	},
	methods: {
		createAlt: function(logo) {
			return !logo.alt ? "Unknown logo" : logo.alt;
		}
	}
};
</script>

<style scoped>
#divLogoLine {
	padding-top: 15px;
	padding-bottom: 15px;
}
#divLogoLine {
	text-align: center;
}
.application_title {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
@media only screen and (min-width: 960px) {
	#longLogos {
		display: block;
	}
	#smallLogo {
		display: none;
	}
	a img {
		height: 34px;
		margin-right: 15px;
	}
}
@media only screen and (max-width: 960px) {
	#longLogos {
		display: none;
	}
	#smallLogo {
		display: block;
	}
	a img {
		width: 216px;
		margin-right: auto;
		margin-left: auto;
	}
}
</style>
